import { AmbassadorToolState, isAmbassadorTesting } from 'services/ambassador';
import {
  CENTRAL_IA_AMBASSADOR_SLUG,
  CONTRACT_CLAUSES_AMBASSADOR_SLUG,
  PRICE_INTELLIGENCE_AMBASSADOR_SLUG,
} from 'services/ambassador_tools';

const ALFA_ONLY_ICONS = ['conlicitacao_academy'];

const ALFA_ONLY_NAMES = ['Central IA', 'Análise de Cláusulas Contratuais', 'Gestão IA'];

const ALFA_ONLY_LINKS = ['/validar_contrato', '/pesquisa_de_precos', '/gestao_ia'];

interface AlfaTool {
  name: string;
  icon: string;
  link?: string;
}

// Clientes (fora do grupo alfa) com acesso liberado à Análise de Mercado 3.0.
const PRICE_INTELLIGENCE_CLIENT_IDS = [139359];

export interface ToolAccessProfile {
  alfa_tester?: boolean;
  clientId?: number;
  ambassador?: { member?: boolean; subscriber?: boolean; tools?: AmbassadorToolState[] };
}

export const isAlfaOnlyTool = ({ name, icon, link }: AlfaTool): boolean =>
  ALFA_ONLY_ICONS.includes(icon) ||
  ALFA_ONLY_NAMES.includes(name) ||
  ALFA_ONLY_LINKS.includes(link || '');

// O embaixador entra durante o prazo do teste da ferramenta.
export const canAccessPriceIntelligence = (profile?: ToolAccessProfile): boolean =>
  profile?.alfa_tester === true ||
  PRICE_INTELLIGENCE_CLIENT_IDS.includes(profile?.clientId ?? 0) ||
  isAmbassadorTesting(profile?.ambassador, PRICE_INTELLIGENCE_AMBASSADOR_SLUG);

export const canAccessCentralIa = (profile?: ToolAccessProfile): boolean =>
  profile?.alfa_tester === true ||
  isAmbassadorTesting(profile?.ambassador, CENTRAL_IA_AMBASSADOR_SLUG);

export const canAccessContractClauses = (profile?: ToolAccessProfile): boolean =>
  profile?.alfa_tester === true ||
  isAmbassadorTesting(profile?.ambassador, CONTRACT_CLAUSES_AMBASSADOR_SLUG);

// Mesma regra das rotas (routes/with_tool_access) para o menu e "Nossas Ferramentas".
export const canSeeTool = (tool: AlfaTool, profile?: ToolAccessProfile): boolean => {
  if (profile?.alfa_tester === true) return true;
  if (tool.link === '/pesquisa_de_precos') return canAccessPriceIntelligence(profile);
  if (tool.name === 'Central IA') return canAccessCentralIa(profile);
  if (tool.name === 'Análise de Cláusulas Contratuais' || tool.link === '/validar_contrato') {
    return canAccessContractClauses(profile);
  }
  return !isAlfaOnlyTool(tool);
};

interface RepresentantProfile {
  representant?: boolean;
  alfa_tester?: boolean;
}

export const canUseRepresentantPlatform = (profile?: RepresentantProfile): boolean =>
  profile?.representant === true && profile?.alfa_tester === true;
